<template>
  <span>
    <rele-connection-dialog
      v-model="dialog.open"
      :type="name"
      :authType="dialog.authType"
      @on-api-key="onApiKeyClick"
      @on-oauth="onOauthClick"
      @on-close="onCloseDialog"
      class="shadow-lg"
    />

    <div
      align="center"
      class="flex flex-col border border-solid border-gray-400 rounded-lg p-4 bg-white hover:shadow cursor-pointer max-w-sm w-full"
      @click="toggleDialog"
    >
      <!-- image -->
      <div>
        <div class="flex flex-col justify-center h-20 w-20">
          <div>
            <img :src="images[name]" />
          </div>
        </div>
      </div>

      <!-- divider -->
      <hr class="divide-y divide-gray-400 my-2" />

      <!-- description -->
      <div
        v-html="$t(`nonActiveIntegrations.${name}.title`)"
        class="font-bold mb-2"
      />

      <div v-html="$t(`nonActiveIntegrations.${name}.description`)" />
    </div>
  </span>
</template>

<script>
import hubspotIcon from "@/assets/icons/hubspot.png"
import salesforceIcon from "@/assets/icons/salesforce.png"
import mailingIcon from "@/assets/icons/mailing.png"

const upper = (name) => name.charAt(0).toUpperCase() + name.slice(1)

/**
 * Define the new integration component
 */
export default {
  // set the component name
  name: "rele-new-integration",

  // component state
  data() {
    return {
      // icons
      images: {
        hubspot: hubspotIcon,
        salesforce: salesforceIcon,
        mailing: mailingIcon
      },

      // dialog data
      dialog: {
        open: false,
        component: "",
        authType: ""
      }
    }
  },

  // external props
  props: {
    // the integration name
    name: {
      type: String,
      default: ""
    }
  },

  // component functions
  methods: {
    /**
     * Toggle the relevant dialog
     */
    toggleDialog() {
      if (this.dialog.open) {
        // should close dialog
        this.$set(this.dialog, "open", false)
      } else {
        // should open dialog
        this.$set(this.dialog, "component", `Rele${upper(this.name)}Connection`)
        this.$set(this.dialog, "open", true)
      }
    },

    /**
     * On Api key choose
     */
    onApiKeyClick() {
      this.$set(this.dialog, "authType", "apiKey")
    },

    /**
     * On Oauth
     */
    onOauthClick() {
      this.$set(this.dialog, "authType", "oauth")
    },

    /**
     * On close integration dialog
     */
    onCloseDialog() {
      this.$set(this.dialog, "authType", "")
    }
  }
}
</script>
